import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PresentationRecord from '../../../records/PresentationRecord';
import { trackInteraction } from '../../../tracking/tracker';
import { CLICK_DOWNLOAD } from '../../../tracking/actions';
import { ButtonWithBranding } from '../../ButtonWithBranding';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ViewToolbarDownloadButton extends Component {
  constructor(...args) {
    super(...args);
    this.handleDownloadClick = () => {
      const {
        presentation,
        fetchDownloadLink
      } = this.props;
      if (!presentation.id) return;
      trackInteraction(CLICK_DOWNLOAD);
      fetchDownloadLink(presentation.id, presentation.accessId || undefined).then(downloadUrl => {
        window.location = downloadUrl;
      }).catch(err => {
        console.error(err);
      });
    };
  }
  render() {
    const {
      brandingColor
    } = this.props;
    return /*#__PURE__*/_jsx(ButtonWithBranding, {
      marginInlineStart: "300",
      marginInlineEnd: "800",
      brandingColor: brandingColor,
      onClick: this.handleDownloadClick,
      "aria-label": I18n.text('a11y.downloadButton'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "view.toolbar.download"
      })
    });
  }
}
ViewToolbarDownloadButton.propTypes = {
  presentation: PropTypes.instanceOf(PresentationRecord).isRequired,
  brandingColor: PropTypes.string.isRequired,
  fetchDownloadLink: PropTypes.func.isRequired
};